module.exports = __webpack_public_path__ + "static/media/wilson-architecture.48d4fe92.png";